import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DownloadArquivoRoutingModule } from './download-arquivo-routing.module';
import { DownloadArquivoComponent } from './download-arquivo.component';
import { AppConfigModule } from 'src/app/layout/config/app.config.module';
import { MessagesModule } from 'primeng/messages';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    DownloadArquivoComponent
  ],
  imports: [
    CommonModule,
    DownloadArquivoRoutingModule,
    FormsModule,
    AppConfigModule,
    MessagesModule,
    ButtonModule,
    ProgressSpinnerModule
  ]
})
export class DownloadArquivoModule { }
